import { render } from "./inputBase.vue?vue&type=template&id=3fb53210&scoped=true"
import script from "./inputBase.vue?vue&type=script&lang=js"
export * from "./inputBase.vue?vue&type=script&lang=js"

import "./inputBase.vue?vue&type=style&index=0&id=3fb53210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb53210"]])

export default __exports__